export default __webpack_public_path__ + "static/our_client-87b02e33a512316a409903622f69195b.png";